import React from 'react';
import { Text } from '../../../../components/Typography/Text';
import style from './FeatureToggle.scss';

interface FeatureToggleProps {
  title: string;
  subtitle: string;
  enabled: boolean;
  onChange?: (enabled: boolean) => void;
}

const FeatureToggle: React.FC<FeatureToggleProps> = ({ title, subtitle, enabled, onChange }) => {
  const handleToggle = () => {
    if (onChange) {
      onChange(!enabled);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.textContent}>
        <Text className={style.title}>{title}</Text>
        <Text className={style.subtitle}>{subtitle}</Text>
      </div>
      <div className={style.toggleContainer}>
        <button
          type="button"
          className={`${style.toggle} ${enabled ? style.enabled : style.disabled}`}
          onClick={handleToggle}
          role="switch"
          aria-checked={enabled}
        >
          <div className={style.toggleKnob} />
        </button>
      </div>
    </div>
  );
};

export default FeatureToggle;
